import { toStrDateTime } from 'Domain/Common/dateFormat.js';

export default (obj) => {
    const date = obj.date_create;
    return date ? toStrDateTime(obj.date_create) : toStrDateTime(new Date());
};
